import React from 'react';
import { Outlet } from 'react-router-dom';
import PageLayout from '../../ui/PageLayout';

export default function CeramicsWorldLayout({ children }) {
  return (
    <PageLayout showOuterHeader={false}>
      {children ?? <Outlet />}
    </PageLayout>
  );
}
